import { render, staticRenderFns } from "./article-card.vue?vue&type=template&id=ef7d9bb6&scoped=true"
import script from "./article-card.vue?vue&type=script&lang=js"
export * from "./article-card.vue?vue&type=script&lang=js"
import style0 from "./article-card.vue?vue&type=style&index=0&id=ef7d9bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d9bb6",
  null
  
)

export default component.exports